import { Component } from "react";
import {
  message,
  Modal,
  Typography,
  List,
  Checkbox,
  Tag,
  Card,
  Row,
  Col,
  Divider,
  Collapse,
  Tooltip,
} from "antd";
import { connect } from "react-redux";
import axios from "axios";
import { ModalItem, ButtonItem, Form } from "../../../../Components/Items";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import listaEmpaquetadoPdf from "../../../../Pdf/listaEmpaquetadoPdf";
import {
  BoxPlotOutlined,
  UserOutlined,
  MailOutlined,
  PhoneOutlined,
  DownloadOutlined,
  CheckSquareOutlined,
  CheckCircleOutlined,
  InboxOutlined,
} from "@ant-design/icons";

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const { Text, Title } = Typography;

class ModalConfirmarEmpaquetadoSucursal extends Component {
  state = {
    loading: false,
    venta: null,
    insumosFiltrados: [],
    itemsEmpaquetados: {},
    insumosBloqueados: {}, // { [insumoId]: bool } — ya empaquetado desde el servidor
    enviarCorreo: this.props.enviarCorreoDefault !== false,
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible && this.props.ventaId) {
      this.setState({ enviarCorreo: this.props.enviarCorreoDefault !== false });
      this.consultarVentaDetalle();
    }
    if (!this.props.visible && prevProps.visible) {
      this.setState({
        venta: null,
        insumosFiltrados: [],
        itemsEmpaquetados: {},
        insumosBloqueados: {},
        enviarCorreo: this.props.enviarCorreoDefault !== false,
      });
    }
  }

  consultarVentaDetalle = () => {
    this.setState({ loading: true });
    const { ventaId, empresaId, headersToken } = this.props;

    axios
      .post(
        "ventasEcommerce/obtenerVentaPorId",
        { ventaId, empresaId },
        { headers: headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const venta = res.data.venta;

          const filtrados = (venta.insumos || []).filter(
            (ins) => !ins.servicio && !ins.libroVirtual,
          );

          const itemsEmpaquetadosObj = {};
          const insumosBloqueadosObj = {};
          filtrados.forEach((ins) => {
            itemsEmpaquetadosObj[ins._id] = ins.empaquetado || false;
            insumosBloqueadosObj[ins._id] = !!ins.empaquetado;
          });

          this.setState({
            venta,
            insumosFiltrados: filtrados,
            itemsEmpaquetados: itemsEmpaquetadosObj,
            insumosBloqueados: insumosBloqueadosObj,
            loading: false,
          });
        } else {
          this.setState({ loading: false });
          message.warning(res.data.message);
        }
      })
      .catch(() => {
        this.setState({ loading: false });
        message.error("Error al obtener el detalle de la venta");
      });
  };

  handleToggleEmpaquetado = (insumoId) => {
    const { insumosBloqueados, itemsEmpaquetados } = this.state;
    if (
      insumosBloqueados[insumoId] &&
      itemsEmpaquetados[insumoId] &&
      !this.props.permisoDesempaquetar
    ) {
      return message.warning(
        "No tienes permiso para desempaquetar un insumo ya confirmado.",
      );
    }
    this.setState((prev) => ({
      itemsEmpaquetados: {
        ...prev.itemsEmpaquetados,
        [insumoId]: !prev.itemsEmpaquetados[insumoId],
      },
    }));
  };

  validarTodoEmpaquetado = () => {
    const { insumosFiltrados, itemsEmpaquetados, venta } = this.state;
    if (!venta) return false; 
    if (insumosFiltrados.length === 0) return true;
    return insumosFiltrados.every((ins) => itemsEmpaquetados[ins._id]);
  };

  validarAlgunoEmpaquetado = () => {
    const { insumosFiltrados, itemsEmpaquetados, venta } = this.state;
    if (!venta) return false;
    if (insumosFiltrados.length === 0) return true;
    return insumosFiltrados.some((ins) => itemsEmpaquetados[ins._id]);
  };

  marcarTodoListo = () => {
    const { insumosFiltrados, itemsEmpaquetados, insumosBloqueados } = this.state;
    const permiso = this.props.permisoDesempaquetar;
    const todosMarcados = insumosFiltrados.every((ins) => itemsEmpaquetados[ins._id]);
    const nuevoValor = !todosMarcados;
    const nuevos = { ...itemsEmpaquetados };
    insumosFiltrados.forEach((ins) => {
      if (!nuevoValor && insumosBloqueados[ins._id] && !permiso) return;
      nuevos[ins._id] = nuevoValor;
    });
    this.setState({ itemsEmpaquetados: nuevos });
  };

  marcarPorObligatorio = (valor) => {
    const { insumosFiltrados, itemsEmpaquetados, insumosBloqueados } = this.state;
    const permiso = this.props.permisoDesempaquetar;
    const objetivo = insumosFiltrados.filter((ins) => ins.obligatorio === valor);
    if (objetivo.length === 0) return;
    const todosMarcados = objetivo.every((ins) => itemsEmpaquetados[ins._id]);
    const nuevoValor = !todosMarcados;
    this.setState((prev) => {
      const nuevos = { ...prev.itemsEmpaquetados };
      objetivo.forEach((ins) => {
        if (!nuevoValor && insumosBloqueados[ins._id] && !permiso) return;
        nuevos[ins._id] = nuevoValor;
      });
      return { itemsEmpaquetados: nuevos };
    });
  };

  descargarPdfEmpaque = async () => {
    const { ventaId, empresaId, origenKey, headersToken } = this.props;
    const { venta } = this.state;
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ventasEcommerce/datosPdfEmpaquetado",
        { ventaId, empresaId, origenKey },
        { headers: headersToken },
      );
      if (res.data.success !== 2) {
        return message.warning(
          res.data.message || "No se pudieron obtener los datos del PDF.",
        );
      }
      const dd = listaEmpaquetadoPdf(res.data);
      pdfMake
        .createPdf(dd)
        .download(`Empaquetado_${venta?.serieNumero || ventaId}.pdf`);
    } catch (err) {
      message.error("No se pudo generar el PDF de la lista.");
    } finally {
      this.setState({ loading: false });
    }
  };

  guardarProgreso = () => {
    const { ventaId, empresaId, headersToken } = this.props;
    const { itemsEmpaquetados } = this.state;

    const insumosAActualizar = Object.keys(itemsEmpaquetados).map((id) => ({
      insumoId: id,
      empaquetado: itemsEmpaquetados[id],
    }));

    this.setState({ loading: true });
    axios
      .post(
        "ventasEcommerce/guardarProgreso",
        { ventaId, empresaId, insumos: insumosAActualizar },
        { headers: headersToken },
      )
      .then((res) => {
        this.setState({ loading: false });
        if (res.data.success === 2) message.success("Progreso guardado");
      })
      .catch(() => this.setState({ loading: false }));
  };

  confirmarEmpaquetado = async () => {
    if (this.props.soloActualizar) {
      return this.actualizarProgresoYCerrar();
    }
    if (!this.validarTodoEmpaquetado()) {
      const { insumosFiltrados, itemsEmpaquetados } = this.state;
      const listos = insumosFiltrados.filter(
        (ins) => itemsEmpaquetados[ins._id],
      ).length;
      return Modal.confirm({
        title: "¿Confirmar empaquetado parcial?",
        content: `Vas a confirmar el empaquetado con ${listos} de ${insumosFiltrados.length} insumos listos. El resto quedará pendiente. ¿Continuar?`,
        okText: "Sí, continuar",
        cancelText: "Cancelar",
        onOk: () => this.ejecutarConfirmarEmpaquetado(),
      });
    }
    this.ejecutarConfirmarEmpaquetado();
  };

  actualizarProgresoYCerrar = async () => {
    const { ventaId, empresaId, headersToken } = this.props;
    const { itemsEmpaquetados } = this.state;
    this.setState({ loading: true });

    const insumosAActualizar = Object.keys(itemsEmpaquetados).map((id) => ({
      insumoId: id,
      empaquetado: itemsEmpaquetados[id],
    }));

    try {
      await axios.post(
        "ventasEcommerce/guardarProgreso",
        { ventaId, empresaId, insumos: insumosAActualizar },
        { headers: headersToken },
      );
      this.setState({ loading: false });
      message.success("Empaquetado actualizado");
      this.props.onSuccess();
    } catch (err) {
      this.setState({ loading: false });
      message.error("Error al actualizar el empaquetado.");
    }
  };

  ejecutarConfirmarEmpaquetado = async () => {
    const { ventaId, empresaId, origenKey, headersToken } = this.props;
    const { enviarCorreo, itemsEmpaquetados } = this.state;
    this.setState({ loading: true });

    const insumosAActualizar = Object.keys(itemsEmpaquetados).map((id) => ({
      insumoId: id,
      empaquetado: itemsEmpaquetados[id],
    }));

    try {
      await axios.post(
        "ventasEcommerce/guardarProgreso",
        { ventaId, empresaId, insumos: insumosAActualizar },
        { headers: headersToken },
      );

      const res = await axios.post(
        "ventasEcommerce/actualizarEstadoPaquete",
        { ventaId, empresaId, origenKey, nuevoEstado: 2, enviarCorreo },
        { headers: headersToken },
      );

      this.setState({ loading: false });
      if (res.data.success === 1) {
        message.success(
          "Pedido empaquetado y listo para recolección en sucursal",
        );
        this.props.onSuccess();
      } else {
        message.warning(
          res.data.message || "No se pudo confirmar el empaquetado.",
        );
      }
    } catch (err) {
      console.error(err);
      this.setState({ loading: false });
      message.error("Error al confirmar el empaquetado.");
    }
  };

  render() {
    const { visible, onCancel, escuelaActivo, permisoDesempaquetar } = this.props;
    const { venta, insumosFiltrados, itemsEmpaquetados, insumosBloqueados, loading, enviarCorreo } =
      this.state;

    const algunoListo = this.validarAlgunoEmpaquetado();

    return (
      <ModalItem
        title={
          <span>
            <BoxPlotOutlined /> Empaquetado — Entrega en Sucursal
          </span>
        }
        visible={visible}
        onCancel={onCancel}
        width={800}
        spinning={loading}
      >
        <Form
          name="form_empaquetado_sucursal"
          bottom={
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: 8,
                flexWrap: "wrap",
              }}
            >
              <ButtonItem onClick={this.guardarProgreso} loading={loading} cyan>
                Guardar Progreso
              </ButtonItem>
              <ButtonItem
                type="primary"
                onClick={this.confirmarEmpaquetado}
                disabled={this.props.soloActualizar ? false : !algunoListo}
                verde
                icon={<CheckCircleOutlined />}
              >
                {this.props.soloActualizar
                  ? "Actualizar Empaquetado"
                  : "Confirmar empaquetado"}
              </ButtonItem>
            </div>
          }
        >
          {venta && (
            <>
              <Card
                size="small"
                style={{
                  marginBottom: 20,
                  background: "#ffffff",
                  borderRadius: "10px",
                  border: "1px solid #e8e8e8",
                }}
              >
                <Row gutter={16} align="middle">
                  <Col span={14} style={{ borderRight: "1px solid #f0f0f0" }}>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        marginBottom: 6,
                      }}
                    >
                      <Tag
                        color="magenta"
                        style={{ fontSize: "14px", padding: "2px 8px" }}
                      >
                        Folio: {venta.serieNumero}
                      </Tag>
                      <Title
                        level={5}
                        style={{ margin: 0, marginLeft: 8, color: "#333" }}
                      >
                        <UserOutlined /> {venta.clienteOnline?.nombre}{" "}
                        {venta.clienteOnline?.apellidoPaterno}
                      </Title>
                    </div>
                    <div style={{ color: "#8c8c8c", fontSize: "13px" }}>
                      <MailOutlined style={{ marginRight: 5 }} />{" "}
                      {venta.clienteOnline?.email}
                      <Divider type="vertical" />
                      <PhoneOutlined style={{ marginRight: 5 }} />{" "}
                      {venta.clienteOnline?.telefono}
                    </div>
                  </Col>
                  <Col span={10}>
                    <div style={{ textAlign: "right" }}>
                      <div
                        style={{
                          background: "#fff0f6",
                          padding: "4px 12px",
                          borderRadius: "6px",
                          display: "inline-block",
                        }}
                      >
                        <Text type="secondary" style={{ fontSize: "12px" }}>
                          Total de la Venta
                        </Text>
                        <Title level={4} style={{ margin: 0, color: "#eb2f96" }}>
                          ${venta.total?.toFixed(2)}
                        </Title>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Card>

              {(() => {
                const insumosSinEmpaqueFisico = (venta.insumos || []).filter(
                  (ins) => ins.servicio || ins.libroVirtual,
                );
                if (insumosSinEmpaqueFisico.length === 0) return null;
                return (
                  <Collapse style={{ marginBottom: 16 }}>
                    <Collapse.Panel
                      header={`Insumos sin empaque físico (${insumosSinEmpaqueFisico.length})`}
                      key="sin-empaque"
                      extra={<InboxOutlined />}
                    >
                      <List
                        size="small"
                        dataSource={insumosSinEmpaqueFisico}
                        renderItem={(item) => (
                          <List.Item>
                            <List.Item.Meta
                              title={item.descripcion}
                              description={
                                item.libroVirtual ? (
                                  <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
                                    <div>
                                      <Tag color="purple">Código Virtual</Tag>
                                      {item.libroVirtualError ? (
                                        <Tag color="red">Error de asignación</Tag>
                                      ) : (item.entregado || 0) >= (item.cantidad || 0) ? (
                                        <Tag color="green">Entregado</Tag>
                                      ) : (
                                        <Tag color="orange">Pendiente de entregar</Tag>
                                      )}
                                    </div>
                                    {(item.codigosLibroVirtual || []).length > 0 && (
                                      <Text type="secondary" style={{ fontSize: 12 }}>
                                        Lote asignado: {item.codigosLibroVirtual.map((c) => c.numero).join(", ")}
                                      </Text>
                                    )}
                                  </div>
                                ) : (
                                  <Tag color="default">Servicio</Tag>
                                )
                              }
                            />
                            <Text type="secondary">Cant: {item.cantidad}</Text>
                          </List.Item>
                        )}
                      />
                    </Collapse.Panel>
                  </Collapse>
                );
              })()}

              {insumosFiltrados.length > 0 && (
                <List
                  header={
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        flexWrap: "wrap",
                        gap: 8,
                      }}
                    >
                      <Text strong style={{ fontSize: "15px" }}>
                        Confirmar artículos (Picking)
                      </Text>
                      <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                        <Tooltip title="Descargar PDF">
                          <ButtonItem
                            size="small"
                            blanco
                            icon={<DownloadOutlined />}
                            onClick={this.descargarPdfEmpaque}
                          />
                        </Tooltip>
                        <Tooltip title="Marcar todo como listo">
                          <ButtonItem
                            size="small"
                            cyan
                            icon={<CheckSquareOutlined />}
                            onClick={this.marcarTodoListo}
                          />
                        </Tooltip>
                        {escuelaActivo && (
                          <>
                            <Tooltip title="Marcar obligatorios">
                              <ButtonItem
                                size="small"
                                morado
                                icon={<CheckSquareOutlined />}
                                onClick={() => this.marcarPorObligatorio(true)}
                              />
                            </Tooltip>
                            <Tooltip title="Marcar no obligatorios">
                              <ButtonItem
                                size="small"
                                naranja
                                icon={<CheckSquareOutlined />}
                                onClick={() => this.marcarPorObligatorio(false)}
                              />
                            </Tooltip>
                          </>
                        )}
                      </div>
                    </div>
                  }
                  bordered
                  dataSource={insumosFiltrados}
                  style={{
                    background: "white",
                    borderRadius: "8px",
                    marginBottom: 20,
                  }}
                  renderItem={(item) => (
                    <List.Item
                      actions={[
                        <Checkbox
                          checked={
                            itemsEmpaquetados ? itemsEmpaquetados[item._id] : false
                          }
                          disabled={
                            !!insumosBloqueados[item._id] &&
                            !!itemsEmpaquetados[item._id] &&
                            !permisoDesempaquetar
                          }
                          onChange={() => this.handleToggleEmpaquetado(item._id)}
                        >
                          Listo
                        </Checkbox>,
                      ]}
                    >
                      <List.Item.Meta
                        title={
                          <Text strong style={{ color: "#eb2f96" }}>
                            {item.descripcion}
                          </Text>
                        }
                        description={
                          <div style={{ fontSize: 12, marginTop: 4 }}>
                            <Tag color="magenta" style={{ borderRadius: "10px" }}>
                              Cant: {item.cantidad}
                            </Tag>
                          </div>
                        }
                      />
                    </List.Item>
                  )}
                />
              )}

              <div
                style={{
                  padding: "12px 15px",
                  background: "#fff0f6",
                  borderRadius: "8px",
                  border: "1px solid #ffadd2",
                }}
              >
                <Checkbox
                  checked={enviarCorreo}
                  onChange={(e) =>
                    this.setState({ enviarCorreo: e.target.checked })
                  }
                >
                  Notificar al cliente por correo que su pedido está listo para
                  recoger en sucursal
                </Checkbox>
              </div>
            </>
          )}
        </Form>
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
  escuelaActivo: !!state.empresa.escuela,
  permisoDesempaquetar:
    state.user.tipo === 0 ||
    !!state.user.permisos.find(
      (valuePermiso) => valuePermiso.permisoId.toString() === "6a629819f04f1ced48a83955",
    )?.activado,
});

export default connect(mapStateToProps)(ModalConfirmarEmpaquetadoSucursal);
